<template>
  <div>
    <div class="" :class="btnPosition.btnHistoryClass || ''">
      <div
        :class="btnPosition.btnClass || ''"
        :style="btnPosition.btnStyle || ''"
      >
        <button
          class="btn btn-primary wizard-btn next-btn"
          @click="$emit('input')"
        >
          {{ requestButtons.next }}
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="card card-small mb-4 mt-3">
      <div class="card-body">
        <div class="py-2 px-3">
          <div class="row">
            <div class="col-md-6">
              <div class="row" v-if="$route.name !== 'simple-absence-request'">
                <div class="col-md-3">
                  <div class="vacation-heading-wrapper">
                    <h5
                      class="mt-0"
                      v-if="request.hasOwnProperty('leftLeaves')"
                    >{{ parseFloat(request.leftLeaves).toFixed(2) }}</h5>
                    <span
                      v-if="
                        $route.name == 'recovery-time-request' ||
                        $route.name == 'recovery-request'
                      "
                    >
                      {{ $t("days.off.overtime") }}
                    </span>
                    <span v-else>{{ $t("days.off.days") }}</span>

                    <small
                      v-if="
                        $route.name == 'recovery-time-request' ||
                        $route.name == 'recovery-request'
                      "
                    >
                      {{ $t("days.off.counter") }}
                    </small>
                    <small v-else>{{ $t("days.off.paid.vacation") }}</small>
                  </div>
                </div>
              </div>

              <h6 class="desc-heading">
                {{ $t("days.off.description.application") }}
              </h6>
              <p class="mt-0">{{ request.description }}</p>
            </div>
            <div class="col-md-6 video-wrapper">
              <iframe
                v-if="request.videoUrl"
                class="rounded w-100"
                width="560"
                height="315"
                :src="request.videoUrl"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user', 'request', 'requestButtons', 'btnPosition'],
};
</script>
<style scoped>
.vacation-heading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: transparent;
  padding: 15px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px #e9ecef;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vacation-heading-wrapper h5 {
  margin-bottom: 0;
  font-weight: bold;
  color: #303778;
}
.vacation-heading-wrapper span {
  color: #303778;
}
.card {
  position: relative;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}
.next-btn {
  border-radius: 5px !important;
  color: #ffffff !important;
}
</style>
